import React from "react";

const BsFormDelimiter = (props) => {
    return (
        <hr className="bs-form__delimiter"/>
    )
}

export default BsFormDelimiter;
